module.exports = __webpack_public_path__ + "img/topmat.f4d2fc7f.jpeg";